import { render, staticRenderFns } from "./HomeNew.vue?vue&type=template&id=b51181f6&scoped=true&"
import script from "./HomeNew.vue?vue&type=script&lang=js&"
export * from "./HomeNew.vue?vue&type=script&lang=js&"
import style0 from "./HomeNew.vue?vue&type=style&index=0&id=b51181f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b51181f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFlex,VLayout})
